import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { getSupportingDoc } from 'actions';

import NotFoundPage from 'components/Errors/NotFoundPage';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class SupportingDocumentViewer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape().isRequired,
    isFetchingSupportingDoc: PropTypes.bool,
    // eslint-disable-next-line
    supportingDocData: PropTypes.any,
    supportingDocContentType: PropTypes.string,
    getSupportingDocError: PropTypes.shape({}),
    supportingDocFilename: PropTypes.string
  };

  static defaultProps = {
    isFetchingSupportingDoc: false,
    supportingDocContentType: 'application/pdf',
    supportingDocData: null,
    getSupportingDocError: null,
    supportingDocFilename: null
  };

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params: { docId } } = match;
    dispatch(getSupportingDoc(docId));
  }

  render() {
    const {
      isFetchingSupportingDoc,
      supportingDocContentType,
      supportingDocData,
      getSupportingDocError,
      supportingDocFilename
    } = this.props;
    return (
      <div className="original-supporting-doc">
        { !getSupportingDocError && isFetchingSupportingDoc != null && supportingDocData != null && supportingDocContentType != null && <div className="progress-wrapper">
          {
            // eslint-disable-next-line
            isFetchingSupportingDoc
              ? <progress className="progress" max="100" />
              : <object
                  data={ supportingDocData }
                  type={ supportingDocContentType }
                  width="100%"
                  height="100%"
              >
                <p style={ { fontSize: '2rem' } }>The document you selected cannot be displayed in this browser. Please <a href={ supportingDocData } download={ supportingDocFilename }>click here</a> to download and view it.</p>
              </object>
          }
        </div> }
        { getSupportingDocError != null && <div className="page">
          <div className="page-body">
            <NotFoundPage caption="The Supporting Document was not found" />
          </div>
        </div> }
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { forms: {
    isFetchingSupportingDoc,
    supportingDocData,
    supportingDocContentType,
    getSupportingDocError,
    supportingDocFilename
  } } = state;
  return {
    isFetchingSupportingDoc,
    supportingDocData,
    supportingDocContentType,
    getSupportingDocError,
    supportingDocFilename
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(SupportingDocumentViewer, 'SupportingDocumentViewer'));
